module.exports = __webpack_public_path__ + "img/earth-en-m.0236625e.png";